// extracted by mini-css-extract-plugin
module.exports = {"student-name-row":"studentInfo_student-name-row__2aJCH","student-name":"studentInfo_student-name__1KbBY"};